<div
  (keydown.escape)="handlingEscape()"
  *ngIf="errorMessage"
  [ngClass]="{
    'idp-error-tooltip__wrapper--arrow-position-left': arrowPosition === 'left',
    'idp-info-tooltip__wrapper--info': infoToolTip && arrowPosition !== 'top',
    'idp-info-tooltip__wrapper--info-bottom':
      infoToolTip && arrowPosition === 'top',
    'idp-info-tooltip__wrapper--near': config.tooltipPosition === 'near',
    'idp-info-tooltip__wrapper--position': config.position === 'right'
  }"
  aria-live="assertive"
  class="idp-error-tooltip__wrapper idp-error-tooltip__wrapper--formctrl"
  [id]="
    config.position === 'left'
      ? 'tooltipWrapper--' + config.index
      : 'tooltipWrapper' + index
  "
  role="polite"
  tabindex="-1"
  [attr.data-cy]="
    config.position === 'left'
      ? 'tooltipWrapper--' + config.index
      : 'tooltipWrapper' + index
  "
>
  <div #tooltip [style.left]="left" [style.top]="top" class="idp-error-tooltip">
    <span *ngIf="icon" class="idp-error-tooltip__wrapper--icon">
      <i
        aria-hidden="true"
        class="idp-icon-error"
        [attr.data-cy]="'idp-icon-error'"
      ></i>
    </span>
    <span
      [ngClass]="!icon ? 'add_margin' : ''"
      class="idp-error-tooltip__wrapper--message"
    >
      <label
        *ngIf="!!formCtrlId; else formCtrlAbsent"
        [innerHtml]="errorMessage"
        aria-atomic="true"
        aria-live="polite"
        id="label_{{ formCtrlId }}"
        [attr.data-cy]="'label_' + formCtrlId"
      ></label>
      <ng-template #formCtrlAbsent>
        <span [innerHtml]="errorMessage"></span>
      </ng-template>
    </span>
    <span
      *ngIf="closeIcon"
      [ngClass]="{ 'idp-info-tooltip__wrapper--close': infoToolTip }"
      class="idp-error-tooltip__wrapper--close"
    >
      <button
        (click)="closePopupOver($event)"
        (focus)="closeIconFocus()"
        [ngClass]="{ 'idp-info-tooltip__wrapper--close': infoToolTip }"
        aria-label="Close Dialog"
        class="idp_dialog__close idp_dialog__close--light p-0"
        type="button"
      >
        <i
          (keydown.enter)="closePopupOver($event)"
          aria-hidden="true"
          class="idp-close-icon"
          [attr.data-cy]="'idp-close-icon'"
        ></i>
      </button>
    </span>
  </div>
</div>
